import { React, useState, useEffect, Breadcrumb } from "../utils/commonImports";
import GridView from '../components/GridView';
import { _api } from '../auth/Api';
import { Card, Alert } from "antd";
import Select from "react-select";
import { customStyleMd } from "../utils/common";

const Vehicles = () => {
  const [allVehicles, setAllVehicles] = useState([]);
  const [vehiclesList, setVehiclesList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ color: "", vehicleNames: [] });
  const [showExp, setShowExp] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    _getVehicles();
  }, []);

  const _getVehicles = async () => {
    try {
      setLoading(true);
      const payload = {
        itemName: "",
        itemColor: "",
        page: { pageNo: 0, numberOfRecords: 0 },
      };
      await _api("POST", "Vehicle/GetAllVehicles", payload, (res) => {
        const data = res.data || [];
       // console.log("PAI", data)
        const updatedVehicles = data.map(v => ({
          ...v,
          itemName: v.itemName ? v.itemName.toLowerCase() : ""
        }));

        setAllVehicles(updatedVehicles);
        setVehiclesList(updatedVehicles);
        setLoading(false);
        setTotalRecords(res.totalRecords);
      });
    } catch (error) {
      console.log("API Error", error?.message);
      setAllVehicles([]);
      setVehiclesList([]);
      setLoading(false);
    }
  };

  const handleApply = () => {
    if (!filters.color && filters.vehicleNames.length === 0) {
      setShowExp(true);
      return;
    }
    setShowExp(false);

    const filtered = allVehicles.filter((v) => {
      const matchVehicle =
        filters.vehicleNames.length > 0
          ? filters.vehicleNames.includes(v.itemName)
          : true;
      const matchColor = filters.color
        ? v.itemColor?.toLowerCase() === filters.color.toLowerCase()
        : true;
      return matchVehicle && matchColor;
    });

    setVehiclesList(filtered);
  };

  const handleReset = () => {
    setFilters({ color: "", vehicleNames: [] });
    setVehiclesList(allVehicles);
    setShowExp(false);
  };

  const vehicleOptions = Array.from(
    new Set(allVehicles.map((v) => v.itemName))
  ).map((name) => ({ label: name, value: name }));
 // console.log(vehicleOptions)

  //   const vehicleOptions = [
  //     { label: "Alsvin", value: "Alsvin"},
  //     { label: "Karvaan", value: "Karvaan"},
  //     { label: "Oshan", value: "Oshan"},
  //     { label: "Sherpa", value: "Sherpa"}
  // ]
  const colorOptions = Array.from(
    new Set(
      allVehicles
        .filter((v) =>
          filters.vehicleNames.length > 0
            ? filters.vehicleNames.includes(v.itemName)
            : true
        )
        .map((v) => v.itemColor)
    )
  ).map((color) => ({ label: color, value: color }));

  return (
    <>
      <Breadcrumb title="Vehicles" />
      <Card className="mb-3">
        <div className="p-2 bg-white">
          <div className="row g-2">
            <div className="col-12 col-md-6">
              <Select
                isMulti
                options={[
                  { label: "Alsvin", value: "alsvin" },
                  { label: "Karvaan", value: "karvaan" },
                  { label: "Oshan", value: "oshan" },
                  { label: "Sherpa", value: "sherpa" }
                ]}
                value={filters.vehicleNames.map((v) => ({
                  label: v,
                  value: v,
                }))}
                onChange={(selected) =>
                  setFilters({
                    ...filters,
                    vehicleNames: selected ? selected.map((s) => s.value) : [],
                    color: "",
                  })
                }
                placeholder="Select Vehicles"
                styles={customStyleMd}
              />
            </div>

            <div className="col-12 col-md-3">
              <Select
                isClearable
                options={colorOptions}
                value={
                  filters.color
                    ? { label: filters.color, value: filters.color }
                    : null
                }
                onChange={(val) =>
                  setFilters({ ...filters, color: val?.value || "" })
                }
                placeholder="Select Color"
                isDisabled={filters.vehicleNames.length === 0}
                styles={customStyleMd}
              />
            </div>

            <div className="col-12 col-md-3 d-flex justify-content-end gap-2">
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={handleReset}
              >
                Reset Filters
              </button>
              <button
                className="btn btn-sm btn-primary"
                onClick={handleApply}
              >
                Apply Filters
              </button>
            </div>
          </div>

          {showExp && (
            <div className="row pt-3">
              <div className="col-12">
                <Alert
                  showIcon
                  message="NOTE: Please fill at least one filter"
                  type="warning"
                />
              </div>
            </div>
          )}
        </div>
      </Card>

      <GridView
        data={vehiclesList}
        loading={loading}
        totalRecords={totalRecords}
        config={{
          searchField: "itemName",
          titleField: "itemName",
          subtitleField: "itemColor",
          imageField: "imageUrl",
          emptyMessage: "No vehicles found",
          extraFields: [],
        }}
      />
    </>
  );
};

export default Vehicles;